import React from 'react';
import { Flex, Heading, Spinner } from 'core/components';
import { ShimmerText, ToolCallCard } from '../KaizenChatSession.styles';
import { getAgentDisplayName } from '../util/agentDisplayNames';

/**
 * A tool call the model is still writing. It looks like the pending card of a tool call that has started, which
 * replaces it in place once the call has been made.
 */
const StreamingToolCall = ({ toolCall }) => (
  <ToolCallCard elevation={0}>
    <Flex alignItems="center" gap={1} flex={1}>
      <Spinner size={12} />
      <Heading level={6} m={0} color="muted" fontWeight={300}>
        {toolCall.title || <ShimmerText>Preparing {getAgentDisplayName(toolCall.name)}</ShimmerText>}
      </Heading>
    </Flex>
  </ToolCallCard>
);

export default StreamingToolCall;
